import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  notUniqueMobileNumber: {
    id: 'ContactEditorForm.errors.notUniqueMobileNumber',
    defaultMessage: 'Error',
  },
});

export const intlMessages = defineMessages({
  standardFieldsTitle: {
    id: 'GerneralSetting.standardFieldsShortTitle',
  },
  customFieldsTitle: {
    id: 'GerneralSetting.shortTitle',
  },
});
